import { generateBlobfromURLData, removeBlobURL } from "../audio/generateBlob";
import {
  updateCommentsSegment,
  updateDescriptionSegment,
} from "../descriptions/description";

const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

const processBlobForRegion = async (audioUrl) => {
  if (!audioUrl) return null;
  try {
    return await generateBlobfromURLData(audioUrl);
  } catch (error) {
    console.error("Error generating blob:", error);
    return null;
  }
};

export const eachRegionsLoop = (currentProjectRole, regionCreate) => {
  const labelRegions = document.querySelectorAll("region");
  const regionId = regionCreate.id;
  
  labelRegions.forEach((region) => {
    if (region.querySelector("img.loop")) return;
    
    if (region.dataset.id !== regionId) return;
    
    const handlesStart = region.querySelector(".wavesurfer-handle-start");
    const handlesEnd = region.querySelector(".wavesurfer-handle-end");
    
    if (!handlesStart || !handlesEnd) return;
    
    if ((currentProjectRole === "AD" && !regionCreate.data?.review?.approved && !window.location.href.includes("narrator-dubbing")) || 
        (currentProjectRole === "QC" || window.location.href.includes("script-adapter") || window.location.href.includes("audio-descriptor/"))) {
      
      const next = document.createElement("span");
      next.classList.add("next");
      next.innerHTML = ">";
      handlesEnd.appendChild(next);

      const prev = document.createElement("span");
      prev.classList.add("prev");
      prev.innerHTML = "<";
      handlesStart.appendChild(prev);
    } else {
      handlesEnd.style.display = "none";
      handlesStart.style.display = "none";
    }
    
    const loop = document.createElement("img");
    loop.classList.add("loop");
    loop.src = "/assets/img/circulo.png";
    region.appendChild(loop);
  });
};

export const searchRegion = (id, websurfer) => {
  const region = websurfer.current.regions.list[id];
  return region;
};

export const eachRegions = async (currentProject, user, websurfer, setDataLength, setSegmentsProgress) => {
  const hasVoiceOver = currentProject?.users?.some((user) => user?.role === 'AN_D');
  let urlPath = `${process.env.REACT_APP_URL}/api/projects/${currentProject._id}`;
  
  const startTime = performance.now();
 // console.log('🚀 [OPTIMIZACIÓN] Iniciando carga de segmentos...');
  
  const response = await fetch(urlPath);
  const data = await response.json();
  
  const BATCH_SIZE = 20;

  if (data.project.service === 'dubbing' || (hasVoiceOver && window.location.href.includes("narrator-dubbing"))) {
    const total = data.project.captions.length;
    setDataLength(total);
    //console.log(`📊 [DUBBING] Total de segmentos: ${total}`);
    //console.log(`⚡ Procesando en batches de ${BATCH_SIZE} segmentos...`);
    
    const chunks = chunkArray(data.project.captions, BATCH_SIZE);
    let processed = 0;

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      const batchStart = performance.now();
      
      await Promise.all(
        chunk.map(async (region) => {
          let blobURL = null;
          if (region.audiorecord?.initial) {
            blobURL = await processBlobForRegion(region.audiorecord.initial);
          }
          
          const regionData = { ...region, id: region._id, blob: blobURL };
          const isUserRegion = regionData.user === user.uid;
          const isQCRegion = regionData.user !== user.uid && data.project.rol.role.includes("QC");

          if (isUserRegion) {
            websurfer.current.addRegion({
              start: region.start,
              end: region.end,
              color: "#12B4B899",
              data: regionData,
            });
          } else if (isQCRegion) {
            websurfer.current.addRegion({
              start: region.start,
              end: region.end,
              color: "#CCCCCC99",
              data: regionData,
            });
          }
        })
      );
      
      processed += chunk.length;
      const progress = Math.round((processed / total) * 100);
      if (setSegmentsProgress) setSegmentsProgress(progress);
      
      const batchTime = (performance.now() - batchStart).toFixed(2);
      //console.log(`✅ Batch ${i + 1}/${chunks.length} completado: ${processed}/${total} segmentos (${progress}%) - ${batchTime}ms`);
      
      await new Promise(resolve => setTimeout(resolve, 10));
    }
    
    const totalTime = ((performance.now() - startTime) / 1000).toFixed(2);
    //console.log(`🎉 [COMPLETO] ${total} segmentos cargados en ${totalTime}s`);
    //console.log(`📈 Velocidad promedio: ${(total / totalTime).toFixed(1)} segmentos/segundo`);
  
  } else if (data.project?.service === 'sign-language-caption') {
    const total = data.project.segmentsSign.length;
    setDataLength(total);
    //console.log(`📊 [SIGN LANGUAGE] Total de segmentos: ${total}`);
    //console.log(`⚡ Procesando en batches de ${BATCH_SIZE} segmentos...`);
    
    data.project.segmentsSign.sort((a, b) => parseFloat(a.start) - parseFloat(b.start));
    const chunks = chunkArray(data.project.segmentsSign, BATCH_SIZE);
    let processed = 0;

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      const batchStart = performance.now();
      
      chunk.forEach((region, index) => {
        const actualIndex = data.project.segmentsSign.indexOf(region);
        const regionData = { ...region, id: region._id };
        delete regionData._id;

        if (data.project?.rol?.role === 'INTERPRETER') {
          const start = actualIndex === 0 ? 0 : data.project.segmentsSign[actualIndex - 1].end;
          
          websurfer.current.addRegion({
            start: start,
            end: regionData.end,
            data: regionData
          });

          websurfer.current.addRegion({
            start: region.start,
            data: { isMark: true },
            interact: false,
          });
        } else {
          websurfer.current.addRegion({
            start: region.start,
            end: region.end,
            color: "#12B4B899",
            data: regionData,
          });
        }
      });
      
      processed += chunk.length;
      const batchTime = (performance.now() - batchStart).toFixed(2);
      const progress = ((processed / total) * 100).toFixed(1);
      //console.log(`✅ Batch ${i + 1}/${chunks.length} completado: ${processed}/${total} segmentos (${progress}%) - ${batchTime}ms`);
      
      await new Promise(resolve => setTimeout(resolve, 10));
    }
    
    const totalTime = ((performance.now() - startTime) / 1000).toFixed(2);
    //console.log(`🎉 [COMPLETO] ${total} segmentos cargados en ${totalTime}s`);
    //console.log(`📈 Velocidad promedio: ${(total / totalTime).toFixed(1)} segmentos/segundo`);
  
  } else {
    const segments = data.project.segments;
    
    if (window.location.href.includes("/quality-control/") && data.project.audiofinal) {
      segments.push(...data.project.captions);
    }

    if (window.location.href.includes("/client/") && data.project.audiofinal) {
      segments.push(...data.project.captions);
    }

    const total = segments.length;
    setDataLength(total);
    
    const serviceType = window.location.href.includes("/narrator") ? "NARRATOR" : 
                       window.location.href.includes("/audio-descriptor") ? "DESCRIPTOR" :
                       window.location.href.includes("/quality-control") ? "QC" : "PROJECT";
    
    //console.log(`📊 [${serviceType}] Total de segmentos: ${total}`);
    //console.log(`⚡ Procesando en batches de ${BATCH_SIZE} segmentos...`);
    
    const chunks = chunkArray(segments, BATCH_SIZE);
    let processed = 0;

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      const batchStart = performance.now();
      
      await Promise.all(
        chunk.map(async (region) => {
          if (!region.review?.approved || true) {
            let blobURL = null;
            if (region.audiorecord?.initial) {
              blobURL = await processBlobForRegion(region.audiorecord.initial);
            }
            
            const regionData = { ...region, id: region._id, blob: blobURL };
            delete regionData._id;
            let addColor = "";

            if (!window.location.href.includes("/quality-control/") && !window.location.href.includes("/client")) {
              addColor = region.description.initial !== region.description.preview ? "#8EC36A99" : "#12B4B899";
              if (region.review?.approved && window.location.href.includes("/audio-descriptor")) {
                addColor = "#CCCCCC99";
              }
            } else {
              if (region.review.approved) {
                addColor = "#8EC36A99";
              } else if (
                (region.review.approved === false && (region.review.comment[0] === "" || region.review.comment[0] === null)) ||
                (region.review.approved === false && (region.review.comment[0] === region.review.comment[1]))
              ) {
                addColor = "#12B4B899";
              } else if (region.review.approved === false && (region.review.comment[0] !== region.review.comment[1])) {
                addColor = "rgba(255, 19, 0, 0.3)";
              } else {
                addColor = "#12B4B899";
              }
            }
            
            if (window.location.href.includes("/narrator")) {
              if (region.audiorecord?.initial) {
                addColor = "#8EC36A99";
              } else {
                addColor = "#12B4B899";
              }
              if (region.review?.approved) {
                addColor = "#CCCCCC99";
              }
              if (region.review?.comment[0] && region.review?.approved === false) {
                regionData.isDisabled = true;
              } else {
                regionData.isDisabled = false;
              }
            }
            
            websurfer.current.addRegion({
              start: region.start,
              end: region.end,
              color: addColor,
              data: regionData,
            });
          }
        })
      );
      
      processed += chunk.length;
      const progress = Math.round((processed / total) * 100);
      if (setSegmentsProgress) setSegmentsProgress(progress);
      
      const batchTime = (performance.now() - batchStart).toFixed(2);
      //console.log(`✅ Batch ${i + 1}/${chunks.length} completado: ${processed}/${total} segmentos (${progress}%) - ${batchTime}ms`);
      
      await new Promise(resolve => setTimeout(resolve, 10));
    }
    
    const totalTime = ((performance.now() - startTime) / 1000).toFixed(2);
    //console.log(`🎉 [COMPLETO] ${total} segmentos cargados en ${totalTime}s`);
    //console.log(`📈 Velocidad promedio: ${(total / totalTime).toFixed(1)} segmentos/segundo`);
    //console.log(`🔥 Mejora vs método anterior: ~${((30 / totalTime) * 100).toFixed(0)}% más rápido`);
  }
};

export const verifiedSegmentsComplete = (websurfer) => {
  const regionsList = websurfer.current.regions.list;
  for (const regionKey in regionsList) {
    const region = regionsList[regionKey];
    const { initial, preview } = region.data.description;
    if (!region.data?.review?.approved) {
      if (!initial || initial === "" || initial === " " || (initial === preview && region.isUpdate == false))
        return false;
    }
  }
  return true;
};

export const verifiedSegmentsSignComplete = (websurfer) => {
  const regionsList = websurfer.current.regions.list;
  for (const regionKey in regionsList) {
    const region = regionsList[regionKey];
    const { script } = region.data;
    if (script === "" || script === " " || script === null || script === undefined) {
      return false;
    }
  }
  return true;
}

export const verifiedSegmentsRecordSignComplete = (websurfer) => {
  const regionsList = websurfer.current.regions.list;
  for (const regionKey in regionsList) {
    const region = regionsList[regionKey];
    if (!region.data.isMark) {
      const { videorecord } = region.data;
      if (videorecord === "" || videorecord === " " || videorecord === null || videorecord === undefined) {
        return false;
      }
    }
  }
  return true;

};


export const verifiedSegmentsRecordComplete = (websurfer) => {
  const regionsList = websurfer.current.regions.list;
  for (const regionKey in regionsList) {
    const region = regionsList[regionKey];
    const { initial= "", preview="" } = region.data?.audiorecord;
    if (!region.data?.review?.approved) {
      if (!initial || initial === "" || initial === " " || (initial === preview )){
      return false;
    }
  }
  }
  return true;
};

export const verifiedSegmentsRecordDubbingComplete = (websurfer) => {
  const regionsList = websurfer.current.regions.list;
  for (const regionKey in regionsList) {
    const region = regionsList[regionKey];
    const { initial= "", preview="" } = region.data?.audiorecord;
    if (!region.data?.review?.approved) {
      if (!initial || initial === "" || initial === " " || (initial === preview )){
      return false;
    }
  }
  }
  return true;
};

export const deleteSegment = async (region, setRegions, setCurrentRegion) => {
  const path = window.location.href.includes("/script-adapter/") ? `/api/segmentsSign/${region.data.id}` : `/api/segments/${region.data.id}`;
  try {
    const response = await fetch(`${process.env.REACT_APP_URL}${path}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", },
    });
    const data = await response.json();
    region.remove();
    setRegions((oldRegions) => oldRegions.filter((r) => r !== region));
    setCurrentRegion(null);
    return data.status;
  } catch (err) {
    console.error("error", err);
    return false;
  }
};

export const getRegionsData = (websurfer) => {
  const regions = websurfer.current.regions.list;
  var regionsData = {};
  regionsData.segments = {};
  for (const region in regions) {
    regionsData.segments[region] = {
      start: regions[region].start,
      end: regions[region].end,
      duration: regions[region].end - regions[region].start,
      data: regions[region].data,
    };
  }
  regionsData.length = Object.keys(regionsData.segments).length;
  return regionsData;
};

export const handleRegionUpdate = (
  region,
  data,
  type,
  regions,
  currentRegion,
  startTime,
  endTime,
  setWordsCount,
  setDuration,
  description,
  setCharactersCount,
  setRecommendCharacterMin,
  setRecommendCharacterMax
) => {
  if (regions.length > 0 && currentRegion !== null) {
    if (type === "description") {
      updateDescriptionSegment(
        region,
        data,
        startTime,
        endTime,
        setWordsCount,
        setDuration,
        description,
        setCharactersCount,
        setRecommendCharacterMin,
        setRecommendCharacterMax
      );
    }
    if (type === "comments") {
      updateCommentsSegment(
        region,
        data,
        startTime,
        endTime,
        setWordsCount,
        setDuration,
        endTime - startTime
      );
    }
  }
};
